import smoothscroll from 'smoothscroll-polyfill';
import React, { useEffect, useState } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { distributor, amplitudeToken, branchKey } from 'config';
import CpcpayRouter from 'app-router/cpcpay';
import CathaymrRouter from 'app-router/cathaymr';
import MochipayRouter from 'app-router/mochipay';
import AutopassRouter from 'app-router/autopass';
import LineBankRouter from 'app-router/linebank';
import Iknow99Router from './iknow99';
import AutoPartnerRouter from './auto-partner';
import NpcPayRouter from './npcpay';
import { useTranslation } from 'react-i18next';
import localDataService from 'service/local-data-service';
import amplitude from 'amplitude-js';
import ReactPixel from 'react-facebook-pixel';
import branch from 'branch-sdk';
import axios from 'axios';
import { maintenanceConfigUrl } from 'config';
import Maintenance from 'components/maintenance';

export const LANG_PATH = '/:locale(en|tw)?';

const AppRouter = () => {
  const [maintenanceConfig, setMaintenanceConfig] = useState(null);
  const { i18n } = useTranslation();

  useEffect(() => {
    smoothscroll.polyfill();
    localDataService.clearSessionStorage();

    // 導向 https
    const { protocol, host, pathname } = window.location;
    if (protocol.indexOf('https') === -1) {
      window.location.href = `https://${host}${pathname}`;
    }

    // 抓取裝置初始高度
    let h = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--initVh', `${h}px`);
    document.documentElement.style.setProperty('--vh', `${h}px`);

    const onResize = () => {
      let h = window.innerHeight * 0.01;
      document.documentElement.style.setProperty('--vh', `${h}px`);
    };

    window.addEventListener('resize', onResize);
    return () => {
      window.removeEventListener('resize', onResize);
    };
  }, []);

  useEffect(() => {
    if (window.location.pathname.match(RegExp('^(/en$|/en/.*)'))) {
      i18n.changeLanguage('en');
      document.getElementsByTagName('html')[0].setAttribute('lang', 'en');
    } else {
      i18n.changeLanguage('tw');
      document.getElementsByTagName('html')[0].setAttribute('lang', 'zh-Hant-TW');
    }
    // only load once
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    amplitude.getInstance().init(amplitudeToken);
    ReactPixel.init('1937156329929056');
    branch.init(branchKey);
  }, []);

  useEffect(() => {
    axios
      .get(maintenanceConfigUrl(), {
        timeout: 2000,
      })
      .then(res => {
        let data = res.data.default;

        if (data['all'].enabled) {
          setMaintenanceConfig(data['all']);
        } else if (data.hasOwnProperty('web')) {
          setMaintenanceConfig(data['web']);
        } else {
          setMaintenanceConfig({ enabled: false });
        }
      })
      .catch(err => {
        console.log(err);
        setMaintenanceConfig({ enabled: false });
      });
  }, []);

  const DistributorRouter = () => {
    // eslint-disable-next-line default-case
    switch (distributor()) {
      case 'AUTOPASS':
        return <AutopassRouter />;
      case 'CATHAYMR':
        return <CathaymrRouter />;
      case 'CPCPAY':
        return <CpcpayRouter />;
      case 'LINE_BANK':
        return <LineBankRouter />;
      case 'IKNOW99':
        return <Iknow99Router />;
      case 'AUTO_PARTNER':
        return <AutoPartnerRouter />;
      case 'NPCPAY':
        return <NpcPayRouter />;
      case 'NONE':
        return <MochipayRouter />;
    }
  };

  if (!maintenanceConfig) return <></>;

  if (maintenanceConfig.enabled) {
    return <Maintenance title={maintenanceConfig.title} content={maintenanceConfig.content} />;
  }

  return (
    <BrowserRouter>
      <DistributorRouter />
    </BrowserRouter>
  );
};

export default AppRouter;
